let jobsDuplicate = function(id) {
    this.$router.push({
        name: "JobOrderFormDuplicarDash",
        params: { id: id, duplicate: "duplicate", dash: "dash" },
    });
};
export default jobsDuplicate;
